import { QRCodeSVG } from "qrcode.react";
import { Camera } from "lucide-react";
import fetcher from '../../helper/fetcher';
import { useSnackbar } from '../../context/SnackBarContext';
import { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { imageBaseUrl } from "../../utils/utils";
import { useQrAuth } from "../../context/QrAuth";

export default function DashboardQRCard() {
    const { showSuccess, showError } = useSnackbar();
    const [getLink, setGetLink] = useState("");
    const [isLoading, setIsLoading] = useState(false)
    const { user } = useQrAuth()

    const handleGetLink = () => {
        setIsLoading(true)
        fetcher.post("/qr/scan/get_link")
            .then((res) => {
                setGetLink(res?.data?.data)
                window.location.href = res?.data?.data?.qrUrl
                // window.location.href = `http://localhost:3000/contact-card/1`
            })
            .catch((error) => {
                showError(error.response?.data?.message || "Internal server Error");
            }).finally(() => {
                setIsLoading(false)
            })
    }

    // console.log("imageBaseUrl + user?.profile_image", imageBaseUrl  + user?.profile_image)

    return (
        <div className="flex flex-col items-center justify-center pt-12">
            {/* Card */}
            <div className="relative bg-gradient-to-br from-[#bf98ce] to-[#8f77c6] rounded-2xl shadow-lg text-center w-full max-w-sm pt-16 pb-8 px-6">
                {/* Profile Image with camera icon */}
                <div className="absolute -top-14 left-1/2 transform -translate-x-1/2">
                    <div className="relative">
                        <img
                            src={
                                user?.profile_image?.startsWith("https")
                                    ? user?.profile_image
                                    : imageBaseUrl + "images/"+`${user?.profile_image}`
                            }
                            alt="profile"
                            className="w-28 h-28 rounded-full border-4 border-white shadow-md object-cover"
                        />
                        <div className="absolute bottom-1 right-1 bg-white rounded-full p-1 shadow">
                            <Camera size={16} className="text-gray-600" />
                        </div>
                    </div>
                </div>

                {/* Name + subtitle */}
                <h2 className="mt-6 text-xl font-bold text-white mb-6"> {user?.name}
                </h2>

                {/* QR Code box */}
                <div className="bg-white rounded-xl p-4 shadow-md inline-block ">
                    <QRCodeSVG size={200} />
                </div>
            </div>

            {/* Bottom Button */}
            <button disabled={isLoading} onClick={handleGetLink} className="mt-8 w-full max-w-sm py-3 bg-[#7f6bc6] text-white rounded-xl shadow-md hover:opacity-90 transition font-bold">
                {isLoading ? <CircularProgress size={20} color='secondary' /> : "Get the link"}
            </button>
        </div>
    );
}
